import styles from './Tourism.module.css';
import { tourismData } from '../../database/tourismData';

import CardTourismPoints from '../../components/CardTourismPoints';
import Title from '../../components/Title';

export default function Tourism() {
  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <div className={styles.containerHeader}>
          <Title>Pontos Turísticos</Title>
        </div>
        <div className={styles.grid}>
          {tourismData.map(({ id, nome, descricao, url, imagem }) => (
            <CardTourismPoints 
              key={id}
              id={id}
              nome={nome}
              descricao={descricao}
              url={url}
              imagem={imagem}
            />
          ))}
        </div>
      </div>
    </main>
  )
}
